import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24M6 8a1 1 0 0 1 1 1v5a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2v-4a1 1 0 0 1 0-2zm13 2a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1zM9 9.3c0-.72.58-1.3 1.3-1.3h2.4c.72 0 1.3.58 1.3 1.3v1.4c0 .43-.21.81-.53 1.05.32.24.53.62.53 1.05v1.9c0 .72-.58 1.3-1.3 1.3h-2.4A1.3 1.3 0 0 1 9 14.7v-1.9c0-.43.21-.81.53-1.05A1.3 1.3 0 0 1 9 10.7zm2 .2h1v1h-1zm0 3.5h1v1h-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }